import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import Paging, {BasePqForm} from "biz-ts/src/api/Paging";
import ProductActivation from "@/model/ProductActivation";
import _ from "lodash";
import {TestActiveCode} from "@/module/activation/TestActiveCode";
import BatchActionReturn from "biz-ts/src/api/BatchActionReturn";

export class PactPqForm extends BasePqForm {
    productId!: number
    batchCode?: string = undefined
    sequence?: string = undefined
    activeCode?: string = undefined
    usable?: boolean = undefined
    isValid?: boolean = undefined
    isPrinted?: boolean = undefined

    constructor(productId: number) {
        super();
        this.productId = productId;
    }
}

export class PactBatchGenerateForm {
    productId!: number
    number!: number
    batchCode?: string = undefined

    constructor(productId: number) {
        this.init()
        this.productId = productId
    }

    init(): void {
        this.number = 1
        this.batchCode = undefined
    }
}

export class PactBatchEditForm {
    ids?: Array<number> = []
    isPrinted?: boolean = undefined
    batchCode?: string = undefined
}

export class PactStatistics {
    total!: number
    used!: number
    unused!: number
}

export class PactTestcodeForm {
    productId!: number
}

@Singleton
export default abstract class ProductActivationApi {

    abstract paging(form: PactPqForm): Promise<Paging<ProductActivation>>

    abstract batchGenerate(form: PactBatchGenerateForm): Promise<void>

    abstract batchEdit(form: PactBatchEditForm): Promise<void>

    abstract delete(id: number): Promise<void>

    abstract statistics(productId: number): Promise<PactStatistics>

    abstract testcode(form: PactTestcodeForm): Promise<TestActiveCode>

    abstract refreshTestcode(form: PactTestcodeForm): Promise<TestActiveCode>

    abstract batchDelete(ids: Array<number>): Promise<BatchActionReturn>
}

class ProductActivationApiImpl extends BaseApi implements ProductActivationApi {

    protected urlPrefix = 'product/activation'

    paging(form: PactPqForm): Promise<Paging<ProductActivation>> {
        if (_.isEmpty(form.activeCode)) form.activeCode = undefined
        if (_.isEmpty(form.batchCode)) form.batchCode = undefined
        return this.axios.post('paging', form)
    }

    batchGenerate(form: PactBatchGenerateForm): Promise<void> {
        return this.axios.post('batchGenerate', form)
    }

    batchEdit(form: PactBatchEditForm): Promise<void> {
        return this.axios.post('batchEdit', form)
    }

    delete(id: number): Promise<void> {
        return this.axios.post('delete', {id: id})
    }

    statistics(productId: number): Promise<PactStatistics> {
        return this.axios.get('statistics', {params: {productId: productId}})
    }

    testcode(form: PactTestcodeForm): Promise<TestActiveCode> {
        return this.axios.get('testcode', {params: form})
    }

    refreshTestcode(form: PactTestcodeForm): Promise<TestActiveCode> {
        return this.axios.get('testcode/refresh', {params: form})
    }

    batchDelete(ids: Array<number>): Promise<BatchActionReturn> {
        return this.axios.post('batchDelete', {ids: ids})
    }
}

Container.bind(ProductActivationApi).to(ProductActivationApiImpl)
